/** Styling hook for Tooltip-based selection surfaces (not for automation). */
export const SIGNAL_SELECTION_TOOLTIP_SURFACE_CLASS = "signal-selection-tooltip-surface";

/** Styling hook for Popover-based selection surfaces (not for automation). */
export const SIGNAL_SELECTION_POPOVER_SURFACE_CLASS = "signal-selection-popover-surface";
